import { nanoid } from 'nanoid'
import { type ActionItem, toastStore } from 'shared/ui'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { ModalTypeList } from 'shared/ui/Modal/store/types'
import { logger } from 'shared/lib'
import { type RowUser } from 'entities/Users/model/Table/RowUser'
import { UsersApi } from 'entities/Users/api/users'
import { type IUser } from 'entities/Users/model/types'

export const resetPasswordAction = (
  members: RowUser[] | IUser[],
  onSuccess?: () => void | Promise<void>,
  bulk?: {
    all: boolean
    search: string
    total: number
  }
) => {
  const membersCount = bulk?.all ? bulk.total : members.length
  const isSingle = membersCount === 1

  const modalId = nanoid()

  modalStore.addModal({
    id: modalId,
    type: ModalTypeList.WARNING,
    title: 'Reset password?',
    desc: (
      <>
        Member{isSingle ? '' : 's'} will be prompted to
        <br />
        create a new password
      </>
    ),
    primaryAction: {
      text: 'Reset password',
      onAction: async () => {
        try {
          await UsersApi.resetPasswordMembers(
            bulk?.all
              ? { all: true, search: bulk.search }
              : {
                  ids: members.map((member) => member.id),
                  all: false,
                }
          )
          toastStore.add({
            type: 'success',
            title: `Member${isSingle ? '' : 's'} prompted to reset the password`,
          })

          onSuccess?.()
          modalStore.closeModal(modalId)
        } catch (error) {
          logger.error(error)

          toastStore.add({
            type: 'error',
            title: 'Something went wrong. Please try again',
          })
        }
      },
    },
    secondaryAction: {
      text: 'Cancel',
      onAction: () => {
        modalStore.closeModal(modalId)
      },
    },
  })
}

export const resetPassword = (
  members: RowUser[] | IUser[],
  onSuccess?: () => void | Promise<void>,
  bulk?: {
    all: boolean
    search: string
    total: number
  }
): ActionItem => {
  return {
    text: 'Reset password',
    icon: 'refresh',
    onAction: () => {
      resetPasswordAction(members, onSuccess, bulk)
    },
  }
}
